import { render, staticRenderFns } from "./FuncionarioNuevo.vue?vue&type=template&id=1a481de2&"
import script from "./FuncionarioNuevo.vue?vue&type=script&lang=js&"
export * from "./FuncionarioNuevo.vue?vue&type=script&lang=js&"
import style0 from "./FuncionarioNuevo.vue?vue&type=style&index=0&id=1a481de2&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports